import { SUBSCRIPTIONS_GET_BY_APPLICATION } from 'apiRoutes';
import { RequestLoader } from 'components/common/Loader';
import { Subscription } from 'domain/subscription/interfaces/Subscription';
import { useGetOnMount } from 'hooks/useGetOnMount';
import SubscriptionTable from '../SubscriptionTable';
import { subscriptionTableColumns } from '../subscriptionTableColumns';
import { useMemo } from 'react';
import { columnFilters } from './columnFilters';

export const ApplicationSubscriptionsTable: React.FC<{
	id: string | undefined;
}> = ({ id }) => {
	const { data: subscriptions, status: subscriptionsStatus } = useGetOnMount<
		Subscription[]
	>(`${SUBSCRIPTIONS_GET_BY_APPLICATION}?applicationId=${id}`);

	const subscriptionColumns = useMemo(
		() => [
			subscriptionTableColumns.plan(id),
			subscriptionTableColumns.status(),
			subscriptionTableColumns.startDate(),
			subscriptionTableColumns.endDate(),
			subscriptionTableColumns.seats(),
			subscriptionTableColumns.type(),
			subscriptionTableColumns.description(),
			subscriptionTableColumns.owner(true),
			subscriptionTableColumns.expandedIndicator(),
		],
		[subscriptions],
	);

	return (
		<RequestLoader h="800px" status={subscriptionsStatus}>
			<SubscriptionTable
				columns={subscriptionColumns}
				requestStatus={subscriptionsStatus}
				subscriptions={subscriptions}
				filters={columnFilters}
				showRowCount
			/>
		</RequestLoader>
	);
};
